import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import { createRouteGuard } from './permissions.cjs';
import AppLayout from '../layout/AppLayout.vue';
import Login from '../views/Login.vue';
const Dashboard = () => import('../views/Dashboard.vue');
const StoreList = () => import('../views/stores/StoreList.vue');
const UserList = () => import('../views/users/UserList.vue');
const RoleList = () => import('../views/roles/RoleList.vue');
const Profile = () => import('../views/Profile.vue');
const NoPermission = () => import('../views/NoPermission.vue');

Vue.use(VueRouter);
const router = new VueRouter({ mode: 'hash', routes: [
  { path: '/login', component: Login },
  { path: '/403', component: NoPermission },
  { path: '/', component: AppLayout, redirect: '/dashboard', children: [
    { path: 'dashboard', component: Dashboard, meta: { permission: 'dashboard.view' } },
    { path: 'stores', component: StoreList, meta: { permission: 'stores.view' } },
    { path: 'users', component: UserList, meta: { permission: 'users.view' } },
    { path: 'roles', component: RoleList, meta: { permission: 'roles.view' } },
    { path: 'profile', component: Profile }
  ] },
  { path: '*', redirect: '/dashboard' }
] });
router.beforeEach(createRouteGuard({
  getToken: () => store.state.token,
  getPermissions: () => store.getters.permissions,
  refresh: () => store.dispatch('refreshMe')
}));
store.watch((state) => state.token, (token) => {
  if (!token && router.currentRoute.path !== '/login') router.replace('/login').catch(() => {});
});
export default router;
